import {
  IHstSyncStatsResponse,
  IHstSyncStatsRequest,
  IHstSyncRecordsResponse,
  IHstSyncRecordsRequest,
  IHstSyncRecord,
  IHstSyncSettingsListResponse,
  IHstSyncSettingsUpdateResponse,
  IUpdateHstSyncSettingsRequest,
  HstSyncStatus,
} from "types/HstSync";

import { api } from ".";

const buildURLForHstSyncs = ({
  accountId,
  patientName,
  status,
  syncType,
  page,
  pageSize,
}: IHstSyncRecordsRequest): string => {
  const baseUrl = "/hst-sync/syncs";
  const params: string[] = [];

  if (accountId) {
    params.push(`accountId=${accountId}`);
  }
  if (patientName && patientName.length > 0) {
    params.push(`patientName=${encodeURIComponent(patientName)}`);
  }
  if (status) {
    params.push(`status=${status}`);
  }
  if (syncType) {
    params.push(`syncType=${syncType}`);
  }
  if (page !== undefined) {
    params.push(`page=${page}`);
  }
  if (pageSize !== undefined) {
    params.push(`pageSize=${pageSize}`);
  }

  return params.length > 0 ? `${baseUrl}?${params.join("&")}` : baseUrl;
};

const hstSyncQueries = api.injectEndpoints({
  endpoints: (builder) => ({
    getHstSyncStats: builder.query<
      IHstSyncStatsResponse,
      IHstSyncStatsRequest | void
    >({
      query: (params) => {
        const accountId = params?.accountId;
        return accountId
          ? `/hst-sync/syncs/stats?accountId=${accountId}`
          : "/hst-sync/syncs/stats";
      },
    }),
    getHstSyncRecords: builder.query<
      IHstSyncRecordsResponse,
      IHstSyncRecordsRequest
    >({
      query: (params) => buildURLForHstSyncs(params),
    }),
    updateHstSyncStatus: builder.mutation<
      { data: IHstSyncRecord },
      { syncId: string; status: HstSyncStatus }
    >({
      query: ({ syncId, status }) => ({
        url: `/hst-sync/syncs/${syncId}/status`,
        method: "PATCH",
        body: { status },
      }),
    }),
    getHstSyncSettings: builder.query<IHstSyncSettingsListResponse, void>({
      query: () => "/hst-sync/settings",
    }),
    updateHstSyncSettings: builder.mutation<
      IHstSyncSettingsUpdateResponse,
      IUpdateHstSyncSettingsRequest
    >({
      query: ({ accountId, active, allowedIp }) => ({
        url: "/hst-sync/settings",
        method: "PATCH",
        body: { accountId, active, allowedIp },
      }),
    }),
  }),
});

export const {
  useGetHstSyncStatsQuery,
  useGetHstSyncRecordsQuery,
  useUpdateHstSyncStatusMutation,
  useGetHstSyncSettingsQuery,
  useUpdateHstSyncSettingsMutation,
} = hstSyncQueries;
